import { Navigate, useLocation } from "react-router-dom";
import useAuth from "../../Pages/hooks/useAuth";

export default function ProtectedRoute({ children }) {
  const { auth } = useAuth();
  const location = useLocation();

  if (!auth?.accessToken) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (auth?.accessToken && !auth?.user) {
    return null;
  }

  if (!auth.user?.is_staff) {
    return <Navigate to="/" state={{ unauthorized: true }} replace />;
  }

  return children;
}
